import {useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../AppToast';
import {translateError} from '../language';
import {isAsyncFlowCancelled} from '../utils/asyncFlow';

import {useForm, Field} from './Form';

interface DialogCrupProps {
  header: string;
  dataKey?: string;
  width: string;
  fields: Array<Field>;

  defaultValue?: any;

  createItem?(item: any): Promise<any>;

  updateItem?(id: string, item: any): Promise<any>;

  refreshLazyData?(data?: any): void;

  layout?: string;
  formClassName?: string;
}

export const useDialogCrup = (props: DialogCrupProps) => {

  const {header, dataKey, width, fields, defaultValue, createItem, updateItem, refreshLazyData, layout, formClassName} = props;

  const [idUpdate, setIdUpdate] = useState(null);
  const [idClone, setIdClone] = useState(null);
  const [idView, setIdView] = useState(null);
  const [display, setDisplay] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const {render: renderForm, reset, setValue, valid: formValid, getValue, touched} = useForm({
    fields,
    idUpdate,
    layout,
    formClassName
  });

  const create = (_defaultValue?: any) => {
    reset();
    if (_defaultValue) {
      setValue(_defaultValue);
    } else if (defaultValue) {
      setValue(defaultValue);
    }
    setIdUpdate(null);
    setIdClone(null);
    setDisplay(true);
  }

  const update = (item: any) => {
    reset();
    setValue(item);
    setIdUpdate(item[dataKey]);
    setIdClone(null);
    setDisplay(true);
  }

  const clone = (item: any) => {
    reset();
    setValue(item);
    setIdUpdate(null);
    setIdClone(item[dataKey]);
    setDisplay(true);
  }

  const view = (item: any) => {
    reset();
    setValue(item);
    setIdView(item);
    setDisplay(true);
  }

  const handleSubmit = () => {
    if (!submitting && formValid()) {
      setSubmitting(true);

      let promise;
      if (idUpdate) {
        promise = updateItem(idUpdate, getValue());
      } else {
        promise = createItem(getValue());
      }

      promise.then((data) => {
        setDisplay(false);
        ToastService.success();
        refreshLazyData(data);
      }).catch((error) => {
        if (isAsyncFlowCancelled(error)) {
          return;
        }
        // Prevent React error overlay on rejected promise (e.g. API 500)
        ToastService.error(translateError(error?.response || error));
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }

  const render = () => {
    let _header;
    if (header && header[0] === '!') {
      _header = header.substring(1);
    } else {
      _header = `Thêm mới ${header}`;
      if (idClone) {
        _header = `Sao chép ${header}`;
      }
      if (idUpdate) {
        _header = `Chỉnh sửa ${header}`;
      }
    }
    return (
      <Dialog header={_header} visible={display} style={{width}} position="top" onHide={() => setDisplay(false)}>

        {renderForm()}

        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm mr-2"/>
          {!idView &&
						<Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm"/>
          }
        </div>
      </Dialog>
    );
  }

  return {render, create, update, clone, view, getValue, setValue, touched};
}
